import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page09',
  templateUrl: './armenia-page09.component.html',
  styleUrls: ['./armenia-page09.component.css']
})
export class ArmeniaPage09Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
